<template>
    <div class="detail-label">
        <detail-other-info></detail-other-info>
        <div v-if="!isLocalDetail && shareId == ''" class="detail-label-title dsp-flex">
            <div class="note"><span>标签及简要备注：</span><span v-if="confirmedLabelData.length == 0 && remarkStringData == ''">无</span></div>
            <div class="btn">
                <span @click="clickEdit">编辑</span>
                <span v-if="confirmedLabelData.length != 0 || remarkStringData != ''" @click="clickHide">{{hideText}}</span>
            </div>
        </div>
        <div v-if="!hideContent" class="detail-label-list">
            <span class="detail-label-item" v-for="label in confirmedLabelData" v-bind:key="'label'+label.id">{{label.f_title}}</span>
        </div>
        <div v-if="!hideContent" class="detail-label-remark" v-html="UTILS.getBreakLineByText(remarkStringData)"></div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
import DetailOtherInfo from './DetailOtherInfo.vue';
export default {
  components: { DetailOtherInfo },
    name: 'DetailLabel',
    computed: {
        shareId() {
            return this.$store.state.share.shareId
        },
        isLocalDetail() {
            return this.$store.state.detail.isLocalDetail;
        },
        confirmedLabelData() {
            return this.$store.state.label.confirmedLabelData;
        },
        remarkStringData() {
            return this.$store.state.label.remarkStringData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            hideText: '隐藏内容',
            hideContent: false
        }
    },
    methods: {
        clickEdit() {
            var curPath = this.$router.history.current.path;
            this.$router.replace(curPath + '/label');
        },
        clickHide() {
            this.hideContent = !this.hideContent;
            this.hideText = this.hideContent ? '显示内容' : '隐藏内容';
        }
    }
}
</script>